var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifybell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.329,
    height: 24.584,
    viewBox: "0 0 22.329 24.584",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-bell",
    "data-name": "Icon feather-bell",
    transform: "translate(-3.5 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M21.441,9.776a6.776,6.776,0,1,0-13.553,0c0,7.906-3.388,10.165-3.388,10.165H24.829s-3.388-2.259-3.388-10.165",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#6f6f6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M19.313,31.5a2.259,2.259,0,0,1-3.908,0",
    transform: "translate(-2.694 -7.041)",
    fill: "none",
    stroke: "#6f6f6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifybell);
export default __webpack_public_path__ + "static/media/Notifybell.f3aa468abdeabde33eb6266f81c68534.svg";
export { ForwardRef as ReactComponent };